import { createFileRoute } from "@tanstack/react-router";
import { InvoiceDetail } from "@/components/InvoiceDetail";

export const Route = createFileRoute("/_auth/invoices/ar/$invoiceId")({
  component: ARInvoiceDetailPage,
});

function ARInvoiceDetailPage() {
  const { invoiceId } = Route.useParams();
  return <InvoiceDetail invoiceId={invoiceId} direction="ar" />;
}
